const getters = {
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  userId: (state) => state.user.userId,
  isYuShuYuanUser: (state) => state.user.isYuShuYuanUser,
  threePlatform: (state) => state.user.threePlatform,
  paperType: (state) => state.user.paperType,
  testPaperId: (state) => state.user.testPaperId,
  judgeRightOrWrong: (state) => state.user.judgeRightOrWrong,
  backclass: (state) => state.read.backclass,
  isLayout: (state) => state.read.isLayout,
  searchText: (state) => state.read.searchText,
  redirectParams: (state) => state.routerHelp.redirectParams,
  myResourceNum: (state) => state.user.myGoodsNum + state.user.mySubjectNum + state.user.myBundleNum,
  leafletApiURL:(state)=>state.user.leafletApiURL,
}
export default getters
